import React from 'react';

export default (Comp, LoaderComp) => ({ isLoading, ...props }) => {
  if (isLoading) {
    return LoaderComp ? <LoaderComp /> : <div>Loading...</div>;
  }
  return <Comp {...props} />;
};
